import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from 'src/app/authentication/auth.service';
import type { UserCompanyData } from '../../classes/UserInformation';
import type { SimplifiedEmployeeProfile } from '../../classes/EmployeeClasses';
import { FileService } from '../../services/file.service';
import {
  ActionMenuComponent,
  type ActionMenuItem,
} from '../../components/action-menu/action-menu.component';
import { CoreIcons, LucideAngularModule } from '../../shared/core-icons';

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.scss'],
  imports: [CommonModule, RouterLink, ActionMenuComponent, LucideAngularModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopnavComponent {
  readonly icons = CoreIcons;
  private readonly authService = inject(AuthService);
  private readonly fileSvc = inject(FileService);
  private readonly router = inject(Router);

  readonly companyInfo = input<UserCompanyData | null>(null);
  readonly profileInfo = input<SimplifiedEmployeeProfile | null>(null);

  readonly companyLogoUrl = computed(() => this.fileSvc.getLogoUrl());

  readonly items: ActionMenuItem[] = [
    { label: 'Profile', lucideIcon: CoreIcons.user, command: () => this.onProfileView() },
    { label: 'Settings', lucideIcon: CoreIcons.settings, routerLink: '/settings/general' },
    { label: 'Logout', lucideIcon: CoreIcons.logOut, command: () => this.logout() },
  ];

  onProfileView() {
    this.router.navigate(['employee/profile', this.profileInfo().empId, 'personal-information']);
  }

  logout() {
    this.authService.logout();
  }
}
